module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/messages.png", __webpack_public_path__ + "_/_/_/common/components/mobile/images/messages.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/messages.png
// module id = 606
// module chunks = 2